export default {
    USER: 'user',
    PRO: 'pro',
};
